


import * as Actions from '../actions';

const initialState = {
    isLoading: true,
    errMsg: null,
    data: []
    };


// get active categories
export const checkVisitorRed = function(state = initialState, action) {
switch (action.type) {
case Actions.CHECK_VISITOR_EXIST:
return { ...state, isLoading: false, errMsg: null, data: action.payload };
case Actions.CHECK_VISITOR_EXIST_LOADING:
return { ...state, isLoading: true, errMsg: null, data: [] };
case Actions.CHECK_VISITOR_EXIST_LOADING_FAILED:
return { ...state, isLoading: false, errMsg: action.payload, data: [] };
default:
return state;
}
};
